import { X } from "lucide-react";
import { Link } from "react-router-dom";
import userlogo from "../../images/user.png";
import { useEffect } from "react";
import DealCard from "./deal-card";

const History = ({ onClose, data, users }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden"; // page scroll disable
    return () => {
      document.body.style.overflow = "auto"; // restore scroll when popup closes
    };
  }, []);
  const getInitials = (name) => {
    if (!name) return "NA";

    const parts = name.trim().split(" ").filter(Boolean);

    if (parts.length === 1) {
      // single name → first 2 letters
      return parts[0].slice(0, 2).toUpperCase();
    }

    // otherwise → first two words ka first letter
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  function dealinfo(title, description) {
    return (
      <div className="flex flex-col items-center">
        <span className="text-xs text-gray-500 mb-1">{title}</span>
        <span className="font-normal text-slate-900">{description}</span>
      </div>
    );
  }

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center ">
        <div className=" rounded-lg  overflow-hidden shadow-2xl w-[90%] lg:w-[55%]  bg-white">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-black/10 h-[12%] bg-[#1E293B] text-white ">
            <div>
              <h2 className="text-xl font-semibold">History</h2>
            </div>
            <button
              onClick={onClose}
              className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full text-lg flex items-center justify-center transition-all hover:rotate-90"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
          </div>
          <div className="w-[95%] max-h-[500px] overflow-scroll mx-auto my-5">
            <div className="flex items-center gap-4 mb-4 border-b border-black/10 pb-4">
              <div className="w-16 h-16 rounded-full bg-gradient-to-r from-[#0f172a] to-[#1E293B] text-white flex items-center justify-center text-xl font-bold">
                {getInitials(data?.clientName)}
              </div>
              <div>
                <h3 className="font-semibold text-lg text-gray-900">
                  {data?.clientName}
                </h3>
                <div className="flex gap-2 text-xs mt-1">
                  {data.roles.map((type, i) => (
                    <span
                      key={i}
                      className="bg-gray-100 text-gray-600 px-2 py-0.5 rounded"
                    >
                      {type.role}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div div className="grid gap-y-6">
              {data.dealsList.map((item, i) => (
                <DealCard
                  data={item}
                  isShowApprove={false}
                  isShowEdit={false}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default History;
